import React$1 from 'react';

const Default = () => /*#__PURE__*/React$1.createElement("span", {
  className: "icon__icon"
});

export default Default;
